import { useState } from "react";
import { Row, Col, Input } from "reactstrap";
import DataTable from "react-data-table-component";

import { simpleDate, simpleTime } from "../../../utils/displayDate";
import { customTableStyles } from "../styles/table";
import { numberWithCommas } from "../../../utils/math";
import { ChevronIcon } from "../../../constants/icon_path";
import LoadingTable from "../../../components/common/LoadingTable";

const BetListTable = ({ data, loading }) => {
  const [searchValue, setSearchValue] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  // ** Function to handle filter
  const handleFilter = (e) => {
    const value = e.target.value;
    let updatedData = [];
    setSearchValue(value);

    if (value.length) {
      updatedData = data?.filter((item) => {
        const startsWith =
          item.lottery.lotteryNo.toString().startsWith(value.toString()) ||
          item.member.memberId.toString().startsWith(value.toString()) ||
          item.member.nickname.toString().startsWith(value.toString());
        const includes =
          item.lottery.lotteryNo.toString().includes(value.toString()) ||
          item.member.memberId.toString().includes(value.toString()) ||
          item.lottery.lotteryNo.toString().includes(value.toString());

        if (startsWith) {
          return startsWith;
        } else if (!startsWith && includes) {
          return includes;
        } else return null;
      });

      setFilteredData(updatedData);
      setSearchValue(value);
    }
  };

  const renderBetOption = (options) => {
    return options?.map((option, i) => {
      return (
        <span key={option.id}>
          {i !== 0 && "-"}
          {option.name}
        </span>
      );
    });
  };

  const columns = [
    {
      name: "ເລກທີ່ຫວຍ",
      selector: (row) => row.lottery.lotteryNo,
      center: true,
      sortable: true,
      className: "notolao",
      minWidth: "120px",
    },
    {
      name: "ລະຫັດລູກຄ້າ",
      selector: (row) => row.member?.memberId,
      center: true,
      sortable: true,
      className: "notolao",
      minWidth: "130px",
    },
    {
      name: "ຊື່ລູກຄ້າ",
      selector: (row) => row.member?.nickname,
      center: true,
      sortable: true,
      minWidth: "120px",
    },
    {
      name: "ເດີມພັນ",
      selector: (row) => renderBetOption(row.options),
      center: true,
      sortable: true,
      allowOverflow: true,
      minWidth: "120px",
    },
    {
      name: "ເງິນເດີມພັນ",
      selector: (row) => numberWithCommas(row.amount),
      sortable: true,
      center: true,
      minWidth: "120px",
    },

    {
      name: "ເງິນກັບລູກຄ້າ",
      selector: (row) => numberWithCommas(row?.updatedAmount ?? 0),
      sortable: true,
      center: true,
      minWidth: "130px",
    },
    {
      name: "ກຳໄລ",
      cell: (row) => {
        const betAmount = row.amount ?? 0;
        const updatedAmount = row.updatedAmount ?? 0;
        const symbol = updatedAmount - betAmount;
        const increase = symbol >= 1 ? true : false;

        return (
          <span className={increase ? "text-success" : "text-danger"}>
            {increase ? "+" : "-"} {numberWithCommas(row?.difference ?? 0)}
          </span>
        );
      },
      sortable: true,
      center: true,
      minWidth: "100px",
    },
    {
      name: "ວັນທີ່",
      sortable: true,
      center: true,
      cell: (row) => (
        <span className="d-flex flex-column">
          <span>{simpleDate(row.createdAt)}</span>
          <span>{simpleTime(row.createdAt)}</span>
        </span>
      ),
      minWidth: "120px",
    },
  ];

  return (
    <>
      <Row className="mb-2 d-flex">
        <Col md="6">
          <Input
            type="text"
            value={searchValue}
            onChange={handleFilter}
            placeholder="ຄົ້ນຫາ"
            size="sm"
          />{" "}
        </Col>
      </Row>
      <Row>
        <Col md="12">
          <DataTable
            noHeader
            pagination
            data={searchValue.length ? filteredData : data && data}
            columns={columns}
            className="react-dataTable"
            sortIcon={<ChevronIcon size={70} color="red" />}
            filteredData="true"
            customStyles={customTableStyles}
            paginationRowsPerPageOptions={[50, 100, 150, 200]}
            progressComponent={<LoadingTable />}
            progressPending={loading}
            paginationPerPage={50}
          />
        </Col>
      </Row>
    </>
  );
};

export default BetListTable;
